const R = 6371000; // Earth radius in meters

export function haversineDistanceMeters(
  lat1: number,
  lng1: number,
  lat2: number,
  lng2: number
): number {
  const toRad = (d: number) => (d * Math.PI) / 180;
  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

/**
 * Total distance along a sequence of GPS points, in miles.
 */
export function totalDistanceMiles(
  points: Array<{ lat: number; lng: number }>
): number {
  let meters = 0;
  for (let i = 1; i < points.length; i++) {
    meters += haversineDistanceMeters(
      points[i - 1].lat,
      points[i - 1].lng,
      points[i].lat,
      points[i].lng
    );
  }
  return meters / 1609.344;
}

export function paceMinsPerMile(distanceMiles: number, durationSecs: number): number {
  if (distanceMiles <= 0) return 0;
  return durationSecs / 60 / distanceMiles;
}
